"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _commonCta = require("@mmc/common-cta");
var _DealerLocatorTools = _interopRequireDefault(require("../js/DealerLocatorTools"));
var _inputMessages = _interopRequireDefault(require("./input-messages"));
var propTypes = _interopRequireWildcard(require("./mini-dealer-locator.prop-types"));
var _inputSearch = require("./input-search.utils");
var _inputSearch2 = _interopRequireDefault(require("./input-search"));
var _inputSearchAutocomplete = _interopRequireDefault(require("./input-search-autocomplete.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var InputSearchAutocomplete = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(InputSearchAutocomplete, _React$Component);
  function InputSearchAutocomplete(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.inputRef = /*#__PURE__*/_react["default"].createRef();
    _this.search = _this.search.bind((0, _assertThisInitialized2["default"])(_this));
    _this.useLocation = _this.useLocation.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClear = _this.handleClear.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = InputSearchAutocomplete.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      googleAPIKeyFromConfig = _this$props.googleAPIKeyFromConfig,
      market = _this$props.market,
      language = _this$props.language,
      value = _this$props.value;
    this.inputRef.current.value = value || '';
    _DealerLocatorTools["default"].bindAutoComplete({
      inputElement: this.inputRef.current,
      changeFunction: this.search,
      googleAPIKeyFromConfig: googleAPIKeyFromConfig,
      region: market,
      language: language
    });
    this.inputRef.current.addEventListener('keydown', function (e) {
      return e.keyCode === 13 && e.preventDefault();
    }, false);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    _DealerLocatorTools["default"].destroy(this.inputRef.current);
  };
  _proto.handleChange = function handleChange() {
    var onChange = this.props.onChange;
    var value = this.inputRef.current.value;
    onChange(value);
  };
  _proto.handleClear = function handleClear() {
    var onClear = this.props.onClear;
    this.inputRef.current.value = '';
    if (onClear) {
      onClear();
    }
  };
  _proto.useLocation = function useLocation(e) {
    e.preventDefault();
    var _this$props2 = this.props,
      onUseLocationSuccess = _this$props2.onUseLocationSuccess,
      onUseLocationError = _this$props2.onUseLocationError;
    _DealerLocatorTools["default"].getLocation(onUseLocationSuccess, onUseLocationError);
  };
  _proto.search = function search() {
    var _this$props3 = this.props,
      onSearch = _this$props3.onSearch,
      onChange = _this$props3.onChange;
    var value = this.inputRef.current.value;
    onChange(value);
    onSearch(value);
  };
  _proto.render = function render() {
    var _this$props4 = this.props,
      theme = _this$props4.theme,
      label = _this$props4.label,
      value = _this$props4.value,
      locationCtaLabel = _this$props4.locationCtaLabel,
      messages = _this$props4.messages,
      onSearch = _this$props4.onSearch,
      isMapEnabled = _this$props4.isMapEnabled;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: isMapEnabled ? _inputSearchAutocomplete["default"].inputSearchContainer : ''
    }, /*#__PURE__*/_react["default"].createElement(_inputSearch2["default"], {
      ref: this.inputRef,
      theme: theme,
      label: label,
      value: value,
      onChange: this.handleChange,
      onClear: this.handleClear,
      onSearch: onSearch,
      controlled: false,
      error: (0, _inputSearch.hasErrorMessages)(messages)
    }), messages && /*#__PURE__*/_react["default"].createElement(_inputMessages["default"], {
      messages: messages,
      theme: theme
    }), locationCtaLabel && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.black
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      clickEvent: this.useLocation,
      classes: [_inputSearchAutocomplete["default"].useLocation],
      data: {
        label: locationCtaLabel,
        icon: 'Pointer',
        priority: 'lowIcon'
      },
      theme: theme
    })));
  };
  return InputSearchAutocomplete;
}(_react["default"].Component);
exports["default"] = InputSearchAutocomplete;